module.exports = __webpack_public_path__ + "static/media/klaer.8fa4a77c.mp3";